import OrderDetailDialog from "components/Templates/order/OrderDetailDialog"
import React from "react"
import { useSearchParams } from "react-router-dom"

const OrderDetail = () => {
  const [params, setParams] = useSearchParams()
  const orderId = params.get("id")
  const isOpen = orderId ? true : false

  return (
    <OrderDetailDialog
      isOpen={isOpen}
      orderId={orderId}
      onClose={() => {
        params.delete("id")
        setParams(params)
      }}
    />
  )
}

export default OrderDetail
